import { render, staticRenderFns } from "./business-unit.vue?vue&type=template&id=0c0193ae"
import script from "./business-unit.vue?vue&type=script&lang=js"
export * from "./business-unit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports